import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
//import { EvalGoalInterface } from '@tech-interfaces/eval-goal.interface';
import { CommonService } from '@tech-services/common.service';
import { InitcontributionService } from '@tech-services/initcontribution.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FeeInterface, SimulationObjInterface } from '@techrules/portallib';
import { AppConfig } from '@tech-utils/app-config.service';
import { PercentPipe } from '@techrules/pipelib';
import { TechDialogsService } from 'projects/apps/portal-client/src/app/shared/tech-dialogs.service';

@Component({
  selector: 'tech-simulation-init-fees',
  templateUrl: './simulation-init-fees.component.html',
  styleUrls: ['./simulation-init-fees.component.scss'],
})
export class SimulationInitFeesComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  public fees: FeeInterface;
  public currency: string;
  public initialCash: number;
  public labelPeriodic: string;
  public periodicAmount: number;
  public averageData: number;
  public inTerms: number;
  public averageDataWealth: number;
  public inTermsWealth: number;
  public averageTotal: number;
  public inTermsTotal: number;
  public feesInfo: string;
  public feeOf: string;
  public inAmount: string;

  constructor(
    private translate: TranslateService,
    private dialogService: TechDialogsService,
    private commonService: CommonService,
    private initcontributionService: InitcontributionService,
    private percentPipe: PercentPipe
  ) {}

  ngOnInit() {
    this.initcontributionService.fpReferenceData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        if (Object.entries(res).length !== 0) {
          this.initcontributionService.currencyContribution$
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((resp: string) => {
              this.currency = resp;
              if (
                this.initcontributionService.fpReferenceDataSource.getValue()
                  .ProfileId != null
              ) {
                this.initcontributionService.simulationObj$
                  .pipe(takeUntil(this.unsubscribe$))
                  .subscribe((data: SimulationObjInterface) => {
                    if (data.ProfileId !== undefined) {
                      this.initcontributionService
                        .getFees()
                        .pipe(takeUntil(this.unsubscribe$))
                        .subscribe((data: FeeInterface) => {
                          setTimeout(() => {
                            this.fees = data;
                            this.loadfees();
                            this.translate
                              .get('k002271')
                              .subscribe((text: string) => {
                                this.feesInfo = text
                                  .replace('{0}', AppConfig.settings.entityName)
                                  .replace(
                                    '{1}',
                                    AppConfig.settings.infoEntityFAQ
                                  ); //Token: Approximate reference cost on total investment for a period of 12 months. Transaction costs are not included as they fluctuate depending on market performance and specific assets in your portfolio, as well as withdrawals and deposits you make. To learn about the various transaction costs of {0}, visit the Learn section ({1})
                              });
                            this.translate
                              .get('k002449')
                              .subscribe((text: string) => {
                                this.feeOf = text.replace(
                                  '{0}',
                                  data.CustodyName
                                ); //Token: Comisión de {0}
                              });
                            this.translate
                              .get('k002264')
                              .subscribe((text: string) => {
                                this.inAmount = text.replace(
                                  '{0}',
                                  this.currency
                                ); //Token: In amount ({0})
                              });
                          });
                        });
                    }
                  });
              }
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  public viewHintHelp(event) {
    let text1: string;
    this.translate.get('k000163').subscribe((text: string) => {
      text1 = text; //Token: Fees
    });
    let text2: string;
    let text3: string;
    let text4: string;
    let text5: string;
    let textOK: string;
    let implicitFees = this.fees.ImplicitFees;
    let custodyFees = this.fees.CustodyFees;
    let serviceFees = this.fees.ServiceFees;
    this.translate.get('k002266').subscribe((text: string) => {
      text2 = text;
      //toke: <p>Costs considered in the following scheme</p>
    });
    this.translate.get('k003517').subscribe((text: string) => {
      text = serviceFees < 0 ? '' : text;
      text3 = text.replace('{0}', this.percentPipe.transform(serviceFees));
      //toke: <p>Management fee: {0}</p>
    });
    this.translate.get('k003525').subscribe((text: string) => {
      text = implicitFees < 0 ? '' : text;
      text4 = text.replace('{0}', this.percentPipe.transform(implicitFees));
      //toke: <p>Average fund cost: {0}</p>
    });
    this.translate.get('k003526').subscribe((text: string) => {
      text = custodyFees < 0 ? '' : text;
      text5 = text.replace('{0}', this.percentPipe.transform(custodyFees));
      //toke: <p>Custody commission: {0}</p>
      textOK = text2 + text3 + text4 + text5;
      this.dialogService.openModalDialog('', text1, textOK, '');
    });
  }

  public loadfees() {
    if (Object.keys(this.fees).length !== 0) {
      this.translate.get('k002268').subscribe((text: string) => {
        this.labelPeriodic = text; //Token: Yearly amount
      });
      this.averageDataWealth = this.fees.CustodyFees + this.fees.ServiceFees;
      this.inTermsWealth =
        this.initcontributionService.simulationObjSource.getValue()
          .InitialContributionAmount *
        (this.fees.CustodyFees + this.fees.ServiceFees);

      this.averageData = this.fees.ImplicitFees;
      this.inTerms =
        this.initcontributionService.simulationObjSource.getValue()
          .InitialContributionAmount * this.fees.ImplicitFees;
      this.averageTotal = this.averageDataWealth + this.averageData;
      this.inTermsTotal = this.inTermsWealth + this.inTerms;
    }
  }
}
